module.exports = __webpack_public_path__ + "e8d1b8bd41b7143fc2e31b8f7198c648.fbx";